import axios from "vue-app/utils/axios";

const getShouldReinstallModule = async () => {
  const response = await axios.get<boolean>(`/shoper/should-reinstall-module`);
  return response.data;
};

export { getShouldReinstallModule };
